import { FC } from 'react';
import { css } from '@emotion/react';
import { CIBannerPriorityGroupEnum, CIBannerPriorityList } from '@frontend/call-intel-core';
import { useInitPriorityRendererGroup } from '@frontend/priority-renderer';
import { theme } from '@frontend/theme';
import { LocationComparisonCharts } from '../comparison-view/location-comparison-charts';
import { useCallIntelShallowStore } from '../hooks/use-call-intel-store';
import { CallTrends } from '../overview-sections/call-trends';
import { PatientOverview } from '../overview-sections/patient-experience';
import { SchedulingOverview } from '../overview-sections/scheduling-overview';
import { CallIntelSummaryChartsProps } from '../types';

export const CallIntelOverviewPanel: FC<CallIntelSummaryChartsProps> = (props) => {
  const { activeMultiView = 'summary' } = useCallIntelShallowStore('activeMultiView');

  if (activeMultiView === 'summary') {
    return <OverviewTabPanelWithTSS />;
  }

  return <LocationComparisonCharts {...props} />;
};

const OverviewTabPanelWithTSS = () => {
  useInitPriorityRendererGroup({
    groupName: CIBannerPriorityGroupEnum.OVERVIEW_PAGE,
    priorityList: CIBannerPriorityList[CIBannerPriorityGroupEnum.OVERVIEW_PAGE] || [],
    resetPriorityMap: true,
  });

  return (
    <div css={[defaultStyles.container]}>
      <SchedulingOverview />
      <PatientOverview />
      <CallTrends />
    </div>
  );
};

const defaultStyles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
